// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bundleBadge":"_5Q6rs","grid":"gvy-y","list":"nyy4Y","btmLft":"SwkTq","topLft":"dWQyJ","text":"EOADa","circle":"_3IyE3"};